import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function WebApplications() {
  return <ServiceDetailPage service={servicePageContent.webApplications} />;
}
